// extracted by mini-css-extract-plugin
module.exports = {"CopyButton":"CopyButton_CopyButton__3bU71","ToolTip":"CopyButton_ToolTip__FkJ7G"};